<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioCetipAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta CETIP</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioCetipAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.8-8" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="command">
    <th mat-header-cell class="header" *matHeaderCellDef>Comando</th>
    <td mat-cell *matCellDef="let element">
      {{ element.command }}
    </td>
  </ng-container>

  <ng-container matColumnDef="activeIndex">
    <th mat-header-cell class="header" *matHeaderCellDef>Indexador - Ativo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.activeIndex }}
    </td>
  </ng-container>

  <ng-container matColumnDef="activeIndexPercent">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Percentual do Indexador - Ativo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.activeIndexPercent }}
    </td>
  </ng-container>

  <ng-container matColumnDef="activeIndexTax">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Taxa do Indexador - Ativo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.activeIndexTax }}
    </td>
  </ng-container>

  <ng-container matColumnDef="activeIndexBase">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Base do Indexador - Ativo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.activeIndexBase }}
    </td>
  </ng-container>

  <ng-container matColumnDef="activeInterestType">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Tipo de Juros - Ativo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.activeInterestType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="passiveIndex">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Indexador - Passivo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.passiveIndex }}
    </td>
  </ng-container>

  <ng-container matColumnDef="passiveIndexPercent">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Percentual Indexador - Passivo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.passiveIndexPercent }}
    </td>
  </ng-container>

  <ng-container matColumnDef="passiveIndexTax">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Taxa do Indexador - Passivo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.passiveIndexTax }}
    </td>
  </ng-container>

  <ng-container matColumnDef="passiveIndexBase">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Base Indexador - Passivo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.passiveIndexBase }}
    </td>
  </ng-container>

  <ng-container matColumnDef="passiveInterestType">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Tipo de Juros - Passivo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.passiveInterestType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewCounterpart">
    <th mat-header-cell class="header" *matHeaderCellDef>
      É Nova Contraparte?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewCounterpart ? "Sim" : "Não" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartCetipAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta Cetip Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartCetipAccount }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsSwapCetip.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <h4>Erros encontrados:</h4>
          <ul>
            <li *ngFor="let error of element.errors">
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsSwapCetip"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsSwapCetip"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
